"use strict";
export function useIsDarkMode() {
  return true;
}
